import { GetReq } from '@/api/types/getReq';

export const canAssign = (
  request: { type: string; assigned_admin_id: number | null },
  adminType?: string
): boolean =>
  adminType === 'SUPER_ADMIN' &&
  request.type === 'POST_SUBMISSION' &&
  request.assigned_admin_id == null;

export const isAssignedToMe = (
  request: GetReq,
  adminId?: number,
  adminType?: string
): boolean =>
  (adminType === 'ADMIN' || adminType === 'SYSTEM_ADMIN') &&
  request.assigned_admin_id === adminId;

export const canManageChangeRequests = (adminType?: string): boolean =>
  adminType !== 'SYSTEM_ADMIN';

export const canEditDuringReview = (adminType?: string): boolean =>
  adminType !== 'SYSTEM_ADMIN';

export const canReviewPostSubmission = (
  adminType?: string,
  requestStatus?: string,
  stage?: string
): boolean => {
  if (!isReviewableStatus(requestStatus)) {
    return false;
  }

  return (
    stage === adminType ||
    (stage === 'ACADEMIC_SUPERVISION' && adminType === 'ACADEMIC_SUPERVISOR') ||
    adminType === 'SUPER_ADMIN' ||
    adminType === 'ADMIN' ||
    adminType === 'SYSTEM_ADMIN'
  );
};

const ERROR_KEY_MAP: Record<string, string> = {
  request_already_assigned: 'listing-request.error.request_already_assigned',
  admin_not_found_or_inactive:
    'listing-request.error.admin_not_found_or_inactive',
  forbidden: 'listing-request.error.forbidden',
};

export const getRequestErrorMessage = (
  error: unknown,
  translate: (key: string) => string
): string => {
  const axiosError = error as {
    message?: string;
    response?: { data?: { error?: string; message?: string } };
  };

  const errorKey = axiosError.response?.data?.error;

  if (errorKey && ERROR_KEY_MAP[errorKey]) {
    return translate(ERROR_KEY_MAP[errorKey]);
  }

  return (
    axiosError.response?.data?.message ||
    axiosError.message ||
    translate('listing-request.error.generic')
  );
};

export const isReviewableStatus = (status?: string): boolean =>
  status === 'PENDING' || status === 'ASSIGNED';
